import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/passion-painting/back_blue.webp";
import { StaticImage } from "gatsby-plugin-image";

function Paintingjobs() {
  return (
    <section className="five_step" style={{ backgroundImage: `url(${BgImg})` }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center resp_order"
          >
            <div className="fivestep_img">
              <StaticImage
                src="../../../images/case-studies/passion-painting/jobs_img_main.png"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={717}
                height={510}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2>Get Painting Jobs Now!</h2>
            <p>
              Now, if you are a skilled painter but don’t have enough capital to
              seek clients on your own, don’t worry at all! Through the
              specialized Painter’s Dashboard we’ve made for Passion Painting ,
              you can get access to a wide number of painting projects right at
              your fingertips.
            </p>
            <p>
              Signing Up with Passion Painting as a verified painter partner is
              not that difficult. Just provide us with your personal details,
              proof of skills/validation of work and we’ll register you on our
              database. In under 48 hours, you can start getting painting jobs
              worth thousands of dollars!
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Paintingjobs;
